import React from 'react'
import './style.scss'
import { Button, Icon } from 'antd'

function FieldColor({ input, label, meta: { touched, error },}) {

  const colors = ['#61bd4f', '#f2d600', '#ff9f1a', '#eb5a46', '#c377e0', '#0079bf', '#00c2e0', '#51e898', '#ff78cb', '#344563']

  return (
    <div className='FieldColor'>
      <label>{label}</label>
      <div className='color-items'>
        {colors.map(_i => 
          <div className='color_item' style={{background: _i}} onClick={() => {input.onChange(_i)}}>
            {_i == input.value && <Icon type="check-circle" />}
          </div>
        )}
      </div>
      {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
    </div>
  )
}

export default FieldColor


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/components/FormData/components/FormLabel/components/FieldColor/FieldColor.jsx